import React from "react";
import EsenlerSidebar from "../Sidebar/EsenlerSidebar";
import EsenlerOtherServices from "../ServiceAreas/EsenlerServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const EsenlerIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        ESENLER HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Esenler bölgesindeki yaşam yoğunluğu, halı ve koltukların daha sık
            kirlenmesine neden olur. Bu yüzden temizlik hizmetlerimiz, sadece
            görünüm değil, aynı zamanda hijyen ve sağlığınızı da ön planda tutar.
            Modern makinelerimiz ve profesyonel ekibimizle ev tekstil ürünleriniz
            ilk günkü temizliğine kavuşur.
          </p>

          <p>
            Esenler Halı Yıkama olarak; halı, koltuk, yorgan, battaniye ve perde
            gibi tüm ev tekstili ürünlerinde %100 memnuniyet garantili temizlik
            sunuyoruz. Her kumaş türüne özel temizlik maddeleri kullanıyor,
            lekelere karşı özel çözümler uyguluyoruz.
          </p>

          <p>
            <strong>Hizmetimizin başlıca avantajları:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Ücretsiz Alım ve Teslimat – Tüm Esenler geneli</li>
            <li>Organik, cilt dostu temizlik ürünleri</li>
            <li>Koltuklarda buharlı ve köpüklü temizlik sistemi</li>
            <li>Leke çıkartma garantili koltuk ve halı yıkama</li>
            <li>Hızlı kuruma sağlayan vakumlu sistem</li>
            <li>48 saat içerisinde teslim sözü</li>
          </ul>

          <p>
            Esenler genelinde: Nine Hatun, Fevzi Çakmak, Tuna, Oruçreis,
            Kazım Karabekir, Turgut Reis ve diğer tüm mahallelerde hizmet
            veriyoruz. Mobil servis araçlarımız sayesinde sipariş günü içinde
            adresinize gelerek ürünlerinizi alıyoruz.
          </p>

          <p>
            Koltuklarınızın kumaşına zarar vermeyen özel başlıklar ve
            yıkama teknikleriyle temizlik yapıyoruz. Halılarınız ise toz alma,
            yıkama, durulama ve kurutma işlemlerinden geçtikten sonra
            paketlenerek teslim ediliyor.
          </p>

          <p>
            İletişim sayfamızdan kolayca ulaşabilir, kampanyalı fiyatlarımızdan
            faydalanabilirsiniz. Esenler’de halı ve koltuk temizliğinde güvenilir
            ve kaliteli hizmet için doğru adrestesiniz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <EsenlerSidebar />
          <EsenlerOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default EsenlerIntro;
